module.exports = __webpack_public_path__ + "img/somos_placa_azul_es.0490422b.jpg";